export default {
  path: '/clazz',
  component: () => import('../components/Index'),
  children: [
    {
      path: "/",
      redirect: "index",
    },
    {
      path: "index",
      component: () => import('../components/clazz/Index'),
    },
  ]
}


// WEBPACK FOOTER //
// ./src/pages/pc/router/clazz.js